module.exports = __webpack_public_path__ + "static/media/martin_dorner.bfe4b916.jpg";